import { FormattedMessage } from 'react-intl';
import autobind from 'core-decorators/lib/autobind';
import { connect } from 'react-redux';
import { dealInfoHelpers } from 'widget/player-widget';

import { WixConnect } from 'shared/utils/wix-connect';
import WixSDK from 'shared/utils/wix-sdk';
import { notForPreview } from 'widget/utils/not-for-preview';

import { openModal, closeModal, closeCatcher } from 'shared/components/modal/modal';
import { isSignInVisible } from 'shared/utils/layout-helpers';

import { LinkButton } from 'shared/components/button/button';
import Icon from 'shared/components/icon/icon';
import ChannelSubscriptionMobile from 'widget/components/payments/channel-subscription-mobile';

import styles from './account-button-mobile.styl';

import translations from './translations';


@connect(state => ({
  currentSiteUser: state.currentSiteUser,
}))
@WixConnect(styles)
class AccountModalMobile extends React.Component {

  static propTypes = {
    onSubscribeClick: React.PropTypes.func,
    onSubscriptionCancelClick: React.PropTypes.func,
    onUserLogout: React.PropTypes.func,
    channelData: React.PropTypes.object,
    currentSiteUser: React.PropTypes.object,
  };

  static defaultProps = {
    onSubscribeClick: _.noop,
    onSubscriptionCancelClick: _.noop,
    onUserLogout: _.noop,
  };

  @autobind
  logOut() {
    this.props.onUserLogout();
    WixSDK.logOutCurrentMember();
  }

  get channelSubscription() {
    const { channelData, onSubscribeClick, onSubscriptionCancelClick } = this.props;
    let { dealInfo } = channelData;
    dealInfo = dealInfoHelpers.getSubscriptionPriceInfo(dealInfo);

    if (!dealInfo) {
      return null;
    }

    return (
      <ChannelSubscriptionMobile styleName="channel-subscription"
                                 channelData={channelData}
                                 onSubscribeClick={onSubscribeClick}
                                 onSubscriptionCancelClick={onSubscriptionCancelClick} />
    );
  }

  render() {
    const { currentSiteUser } = this.props;

    return (
      <div>
        <div styleName="user-email">
          {currentSiteUser.email}
        </div>
        {this.channelSubscription}
        <div styleName="logout-wrapper">
          <LinkButton styleName="logout"
                      onClick={this.logOut}>
            <FormattedMessage {...translations.logout} />
          </LinkButton>
        </div>
      </div>
    );
  }
}

@connect(state => ({
  isVisible: isSignInVisible(state.appSettings),
  currentSiteUser: state.currentSiteUser,
}))
@WixConnect(styles)
export class AccountButtonMobile extends React.Component {

  static propTypes = {
    isVisible: React.PropTypes.bool,
    onUserLogin: React.PropTypes.func,
    onUserLogout: React.PropTypes.func,
    onSubscribeClick: React.PropTypes.func,
    onSubscriptionCancelClick: React.PropTypes.func,
    channelData: React.PropTypes.object,
    className: React.PropTypes.string,
    currentSiteUser: React.PropTypes.object,
    biEvent: React.PropTypes.func,
  };

  static defaultProps = {
    onSubscribeClick: _.noop,
    onSubscriptionCancelClick: _.noop,
    onUserLogin: _.noop,
    onUserLogout: _.noop,
  };


  @autobind
  @notForPreview
  showLoginForm() {
    const { onUserLogin } = this.props;
    this.props.biEvent('widget.signIn.clicked');
    WixSDK.requestLogin()
      .then(onUserLogin);
  }

  @autobind
  processSubscriptionBuy() {
    const { onSubscribeClick } = this.props;
    this.props.biEvent('widget.subscription.clicked');
    closeModal();
    onSubscribeClick();
  }

  @autobind
  processSubscriptionCancel() {
    const { onSubscriptionCancelClick } = this.props;
    closeModal();
    onSubscriptionCancelClick();
  }

  @autobind
  openAccountInfoPopup() {
    openModal({
      content: this.accountInfoContent,
      contentClassName: styles['popup-wrapper'],
    })
      .catch(closeCatcher);
  }

  get accountInfoContent() {
    const { channelData, currentSiteUser, onUserLogout } = this.props;
    return (
      <AccountModalMobile channelData={channelData}
                          currentSiteUser={currentSiteUser}
                          onUserLogout={onUserLogout}
                          onSubscribeClick={this.processSubscriptionBuy}
                          onSubscriptionCancelClick={this.processSubscriptionCancel} />
    );
  }

  render() {
    const { className, currentSiteUser, isVisible } = this.props;

    if (!isVisible) {
      return null;
    }

    if (!currentSiteUser) {
      return (
        <LinkButton className={className}
                    styleName="account-button"
                    onClick={this.showLoginForm}>
          <FormattedMessage {...translations.signIn} />
        </LinkButton>
      );
    }

    return (
      <div className={className}
           styleName="account-preview-button-wrapper">
        <div styleName="account-preview-button">
          <Icon name="avatar"
                styleName="icon"
                onClick={this.openAccountInfoPopup} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/account/account-button-mobile.js